export default __webpack_public_path__ + "static/media/rgs_main_small.eb0097a8.jpg";